/**
 * 숫자나 문자로 들어온 값에서 숫자를 뽑아 가감산 합니다.
 * ex) 100px + 20 = 120px
 * @param origin {string|number} style 값 100px | 100
 * @param difference {number} 조정할 값
 * @returns {string|number}
 */
export const adjustNumber = (origin: string | number, difference = 0) => {
    if (typeof origin === 'number') {
        return origin + difference
    }
    const originNumber = parseFloat(origin)
    if (!Number.isNaN(originNumber)) {
        const result = `${originNumber + difference}`
        return origin.replace(`${originNumber}`, result)
    }
    throw new Error('origin has not number')
}

/**
 * 10 단위로 올림 합니다.
 * 만약 입력 값이 원하는 단위보다 낮을경우 원하는 단위의 값을 반환합니다.
 * (4) => (3200) === 10000
 * @param digit :number
 */
export const adjustRoundUp = (digit: number) => (value: number) => {
    if (value === 0) {
        return 0
    }
    const n = Math.pow(10, digit)
    const isMinus = value < 0
    const result = Math.abs(value)
    if (result < n) {
        return n * (isMinus ? -1 : 1)
    }
    return Math.ceil(result / n) * n * (isMinus ? -1 : 1)
}

export const adjustToFourDigit = adjustRoundUp(4)

export const roundUpToTenThousand = (value: number, ceilTenThousandWithMin: number): number => {
    // 1만원 단위로 절삭 합니다.
    const result = adjustToFourDigit(value)
    return result > 0 ? result : ceilTenThousandWithMin
}
